function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 148.5,
  y1: 61.5625,
  x2: 148.5,
  y2: 181.5625,
  stroke: "#073C50",
  strokeDasharray: 8
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 88,
  y1: 121.905597,
  x2: 208,
  y2: 121.905597,
  stroke: "#073C50",
  strokeDasharray: 8
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#073C50",
  points: "47 92.5625 128 92.5625 128 101.5625 47 101.5625"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M87.5,47 C105.759915,47 120.5625,61.8025855 120.5625,80.0625 C120.5625,88.2714611 117.570811,95.7816757 112.618252,101.562324 L62.3817483,101.562324 C57.4291893,95.7816757 54.4375,88.2714611 54.4375,80.0625 C54.4375,61.8025855 69.2400855,47 87.5,47 Z",
  fill: "#FFFFFF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M87.5,47.5 C96.4918861,47.5 104.632511,51.144682 110.525165,57.0373354 C116.417818,62.9299889 120.0625,71.0706139 120.0625,80.0625 C120.0625,88.0647893 117.175953,95.392914 112.387157,101.062324 L112.387157,101.062324 L62.6128425,101.062324 C57.8240466,95.392914 54.9375,88.0647893 54.9375,80.0625 C54.9375,71.0706139 58.582182,62.9299889 64.4748354,57.0373354 C70.3674889,51.144682 78.5081139,47.5 87.5,47.5 Z",
  stroke: "#073C50"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M88.21875,55.625 C102.112163,55.625 113.375,66.8878368 113.375,80.78125 C113.375,88.8082497 109.615446,95.9571585 103.761119,100.563194 L72.6763812,100.563194 C66.8220545,95.9571585 63.0625,88.8082497 63.0625,80.78125 C63.0625,66.8878368 74.3253368,55.625 88.21875,55.625 Z",
  fill: "#E2FCA4"
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#073C50",
  points: "78.0364583 70.5989583 78.0364583 74.5832042 91.2958198 74.5832042 78.0694706 87.8095534 81.1907767 90.9308596 94.4167958 77.7045103 94.4167958 90.9635417 98.4010417 90.9635417 98.4010417 74.5832042 98.4010417 70.5989583"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M70,178.5625 L58,178.5625 C54.6862915,178.5625 52,181.248792 52,184.5625 L52,196.5625 C52,199.876208 54.6862915,202.5625 58,202.5625 L76,202.5625 L76,184.5625 C76,181.248792 73.3137085,178.5625 70,178.5625 Z",
  fill: "#E2FCA4"
});

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#073C50",
  points: "66.80309 186.395833 68.1666667 187.75941 65.3633333 190.561833 68.1666667 193.36559 66.80309 194.729167 63.9993333 191.925833 61.19691 194.729167 59.8333333 193.36559 62.6363333 190.561833 59.8333333 187.75941 61.19691 186.395833 63.9993333 189.198833"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M92,142.5625 L116,142.5625 C122.627417,142.5625 128,147.935083 128,154.5625 L128,178.5625 C128,185.189917 122.627417,190.5625 116,190.5625 L80,190.5625 L80,154.5625 C80,147.935083 85.372583,142.5625 92,142.5625 Z",
  fill: "#073C50"
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "114 161.579981 111.086251 158.5625 101.424568 168.568015 96.9137488 163.896669 94 166.914151 101.424568 174.5625"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M227,135.5625 L235,135.5625 C239.418278,135.5625 243,139.144222 243,143.5625 L243,151.5625 C243,155.980778 239.418278,159.5625 235,159.5625 L219,159.5625 L219,143.5625 C219,139.144222 222.581722,135.5625 227,135.5625 Z",
  fill: "#E2FCA4"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M230.999986,153.874997 C234.210114,153.874997 236.812472,151.272639 236.812472,148.062511 C236.812472,144.852382 234.210137,142.250025 230.999986,142.250025 C227.789857,142.250025 225.1875,144.852359 225.1875,148.062511 C225.1875,151.272662 227.789857,153.874997 230.999986,153.874997 Z M234.534004,150.535848 L228.526626,144.528515 C230.172031,143.371749 232.516301,143.480056 234.049394,145.013102 C235.583311,146.547042 235.690015,148.891565 234.534004,150.535848 Z M227.950577,151.111919 C226.416661,149.57798 226.309956,147.233457 227.465967,145.589174 L233.473346,151.596507 C231.827964,152.753273 229.48367,152.644989 227.950577,151.111919 Z",
  fill: "#073C50",
  fillRule: "nonzero"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M202.211839,188.312486 C204.212963,188.312486 205.951313,186.935704 206.409655,184.987749 L208.791211,174.865962 C209.090484,173.594202 209.249816,172.277696 209.249816,170.915128 L209.249816,157.40631 C209.249816,155.444931 207.678695,153.850559 205.726353,153.813183 C203.711629,153.774666 202.062421,155.462127 202.062421,157.47729 L202.062421,165.312541 L201.343673,165.312541 L201.343673,149.481215 C201.343673,147.466053 199.694465,145.778591 197.679741,145.817108 C195.727399,145.854484 194.15619,147.448856 194.15619,149.410235 L194.15619,165.312541 L193.437442,165.312541 L193.437442,145.977317 C193.437442,143.962155 191.788234,142.274693 189.77351,142.31321 C187.821168,142.350586 186.249959,143.944958 186.249959,145.906337 L186.249959,165.312541 L185.531211,165.312541 L185.531211,149.571059 C185.531211,147.555896 183.882003,145.868435 181.867279,145.906952 C179.914937,145.944328 178.343728,147.5387 178.343728,149.500079 L178.343728,170.702451 L175.50032,166.792503 C174.333056,165.187427 172.085476,164.83244 170.480137,165.999879 C168.875149,167.167231 168.52025,169.414811 169.687601,171.020062 L180.972002,186.536497 C181.756203,187.614795 183.025506,188.312486 184.459668,188.312486 L202.211839,188.312486 Z",
  fill: "#073C50",
  fillRule: "nonzero"
});

var _ref16 = /*#__PURE__*/React.createElement("ellipse", {
  fill: "#E2FCA4",
  cx: 234,
  cy: 63.1736111,
  rx: 6.65,
  ry: 6.61111111
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M253,90.5625 C253,80.1304547 244.49341,71.6736111 234,71.6736111 C223.50659,71.6736111 215,80.1304547 215,90.5625",
  fill: "#E2FCA4"
});

var _ref18 = /*#__PURE__*/React.createElement("ellipse", {
  fill: "#E2FCA4",
  cx: 188,
  cy: 63.1736111,
  rx: 6.65,
  ry: 6.61111111
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M207,90.5625 C207,80.1304547 198.49341,71.6736111 188,71.6736111 C177.50659,71.6736111 169,80.1304547 169,90.5625",
  fill: "#E2FCA4"
});

var _ref20 = /*#__PURE__*/React.createElement("ellipse", {
  fill: "#FFFFFF",
  stroke: "#073C50",
  cx: 211,
  cy: 62.0902778,
  rx: 8.95,
  ry: 9.02777778
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M211,74.8402778 C218.317307,74.8402778 224.941697,77.8309303 229.736884,82.6655835 C234.424981,87.3922657 237.364778,93.8813947 237.495454,101.0625 L237.495454,101.0625 L184.504546,101.0625 C184.635222,93.8813947 187.575019,87.3922657 192.263116,82.6655835 C197.058303,77.8309303 203.682693,74.8402778 211,74.8402778 Z",
  stroke: "#073C50"
});

var _ref22 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#073C50",
  points: "129 134.5625 130.732051 135.5625 127.732051 140.758652 126 139.758652"
});

var _ref23 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#073C50",
  points: "136.876558 142.847045 137.360402 144.787636 131.538627 146.239168 131.054784 144.298576"
});

var SvgArtVote = function SvgArtVote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 300 250",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArtVote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/art-vote.2bf88bcc.svg";
export { ForwardRef as ReactComponent };